export default __webpack_public_path__ + "e9fa7c2dae42ef41b046067de011f142.svg";